// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"cef1f1af","344":"cf8d1c27","375":"648098ed","938":"d77c632e"}[chunkId] + ".chunk.js";
};